import React, { useCallback, useEffect, useState } from "react";
import styles from "./Renew.module.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";
import FixedAgent from "../../utils/api/FixedAgent";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { userDataActions } from "../../store/redux-store/Index";
import Menu from "../../components/ui/Menu";

function RenewCart(props) {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [plateNumber, setPlateNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [useCustomerNumber, setUseCustomerNumber] = useState(false);
  const [updateMessage, setUpdateMessage] = useState("");
  const [pinType, setPinType] = useState("");
  const [paymentOption, setPaymentOption] = useState("");

  const token = useSelector((state) => state.userData.loginData.token);

  const userDetails = useSelector((state) => state.userData.personalInfo);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const fetchUserSecondInsuranceData = useCallback(
    async (plate_no) => {
      try {
        setUpdateMessage("Fetching Your Insurance Data");

        const getUserSecondInsuranceRes =
          await FixedAgent.getCustomerInsuranceOnlineData({
            plate_no,
            token,
          });
        setUpdateMessage("Insurance Data Fetched");

        const getUserRoadRes = await FixedAgent.getRoadData({
          plate_no: plate_no,
          token,
        });

        setUpdateMessage("Adding new customer");

        const addNewUser = await FixedAgent.addNewCustomer({
          phone_no: useCustomerNumber
            ? phoneNumber
            : "0" + userDetails?.phone_no,
          plate_no: plateNumber,
          fullname: getUserSecondInsuranceRes.data?.data?.full_name,
          token: token,
          engine_number: getUserSecondInsuranceRes.data?.data?.engine_no,
          chassis: getUserSecondInsuranceRes.data?.data?.chassis_no,
          make: getUserSecondInsuranceRes.data?.data?.make,
          model: getUserSecondInsuranceRes.data?.data?.model,
          year: getUserSecondInsuranceRes.data?.data?.year,
          road_expiry_date: getUserRoadRes.data.data.RwcExp,
          road_message: getUserRoadRes.data.data.message,
          color: getUserSecondInsuranceRes.data?.data?.color,
          state: "lagos",
        });
        setUpdateMessage("Customer Added");

        setIsLoading(false);
        setUpdateMessage("");

        return addNewUser;
      } catch (err) {
        setIsLoading(false);

        if (err?.response?.data?.message === "Unauthenticated") {
          dispatch(userDataActions.logout());
          window.location.reload();
        }
        if (
          err?.response?.data?.message ===
          "Policy details are invalid or not matching."
        ) {
          setUpdateMessage("Redirecting to manual add");
          dispatch(userDataActions.setUserPlateNumber(plateNumber));
          setIsLoading(true);
          navigate("/add-customer");
          setUpdateMessage("");
        } else {
          toast.error(err?.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            style: {
              backgroundColor: "#FFFFFF",
              color: "#000000",
            },
          });
        }
      }
    },
    [
      token,
      dispatch,
      plateNumber,
      phoneNumber,
      navigate,
      useCustomerNumber,
      userDetails?.phone_no,
    ]
  );

  const cartCallBack = useCallback(() => {
    const fetchCartHistory = async () => {
      try {
        setIsLoading(true);
        const productsListRes = await FixedAgent.getManualCartList({
          token,
        });
        setProducts(productsListRes.data);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    fetchCartHistory();
  }, [token]);

  useEffect(() => {
    cartCallBack();
  }, [cartCallBack]);

  useEffect(() => {
    products?.data?.length === 0 ? navigate("/renew") : navigate("/renew/cart");
  }, [navigate, products?.data?.length]);

  const addCustomerHandler = async () => {
    try {
      setLoading(true);
      const getUserRoadRes = await FixedAgent.getRoadData({
        plate_no: plateNumber,
        token,
      });

      let getNiconInsuranceRes;
      try {
        getNiconInsuranceRes = await FixedAgent.getNiconInsuranceData({
          plate_no: plateNumber,
          token,
        });
      } catch (error) {
        console.error(
          "Failed to fetch Nicon insurance data",
          error?.response.data.message
        );

        toast.error(error?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }

      let getInsuranceRes;
      try {
        getInsuranceRes = await FixedAgent.getInsuranceData({
          plate_no: plateNumber,
          token,
        });
        setUpdateMessage("Insurance Data Fetched");
      } catch (error) {
        setUpdateMessage("Insurance Data Fetch Failed");
        console.error("Failed to fetch insurance data", error);
        getInsuranceRes = { data: { message: "" } };
      }

      // const getUserVehicleInfo = await FixedAgent.getCustomerOnlineData({
      //   plate_no: plateNumber,
      //   token,
      // });
      // let insuranceData;
      // if (getUserVehicleInfo.data.data.VehicleMake === "") {
      setUpdateMessage("Fetching Your Insurance Data");

      const getUserInsuranceRes =
        await FixedAgent.getCustomerInsuranceSecondOnlineData({
          plate_no: plateNumber,
          token,
        });
      setUpdateMessage("Insurance Data Fetched");

      // insuranceData = getUserInsuranceRes.data;
      // }
      setUpdateMessage("Adding Customer");

      const addNewUser = await FixedAgent.addNewCustomer({
        phone_no: useCustomerNumber ? phoneNumber : "0" + userDetails?.phone_no,
        plate_no: plateNumber,
        fullname:
          getNiconInsuranceRes.data.fields.insured_name ||
          getUserInsuranceRes.data?.data?.full_name,
        token: token,
        engine_number:
          getNiconInsuranceRes.data.fields.engine_no ||
          getUserInsuranceRes.data?.data?.engine_no,
        chassis:
          getNiconInsuranceRes.data.fields.chasis_no ||
          getUserInsuranceRes.data?.data?.chassis_no,
        make:
          getNiconInsuranceRes.data.fields.vehicle_make_custom ||
          getUserInsuranceRes.data?.data?.make,
        model:
          getNiconInsuranceRes.data.fields.vehicle_model_custom ||
          getUserInsuranceRes.data?.data?.model,
        year:
          getNiconInsuranceRes.data.fields.year_of_make ||
          getUserInsuranceRes.data?.data?.year,
        road_expiry_date: getUserRoadRes.data.data.RwcExp,
        road_message: getUserRoadRes.data.data.message,
        expiry_date: getInsuranceRes.data.message,
        color:
          getNiconInsuranceRes.data.fields.color ||
          getUserInsuranceRes.data?.data?.color,
        state: "lagos",
      });
      setUpdateMessage("Customer Added");

      submitOrderHandler();

      toast.success(`Successfull`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
      setUpdateMessage("");

      navigate("/renew");

      setLoading(false);

      return addNewUser;
    } catch (err) {
      setLoading(false);

      if (
        err?.response?.data?.message ===
        "Policy details are invalid or not matching."
      ) {
        setIsLoading(true);
        fetchUserSecondInsuranceData(plateNumber);
      } else {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }

      if (err?.response?.data?.message === "Unauthenticated") {
        dispatch(userDataActions.logout());
        window.location.reload();
      }
    }
  };

  const removeFromCartHandler = async (id) => {
    try {
      const removeFromCartRes = await FixedAgent.removeFromCart({
        product_id: id,
        token,
      });
      cartCallBack();
      toast.success(removeFromCartRes?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  const closeMenuHandler = () => {
    props.setShowMenu(false);
  };



  const submitOrderHandler = async () => {
    setLoading(true);
    // if (products?.data) {
    const totalPrice = products.data.reduce((sum, item) => {
      return sum + Number(item.product_details.product_price);
    }, 0); // }
    try {
      if (
        totalPrice > userDetails?.wallet?.balance &&
        paymentOption === "WALLET"
      ) {
        toast.error("You don't have enough money in your wallet ", {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
        setLoading(false);
        return;
      }
      // const makeOrderRes = await FixedAgent.makeManualOrder({
      //   plate_no: plateNumber,
      //   token,
      // });

      const makeOrderRes = await FixedAgent.makeManualInsuranceOrder({
        plate_no: plateNumber,
        payment_option: paymentOption,
        pin_type: pinType,
        token,
      });

      toast.success(`Successfull`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });

      navigate(`/history/${makeOrderRes.data.orderID}`);

      setLoading(false);
      return makeOrderRes;
    } catch (err) {
      setLoading(false);
      if (err?.response?.data?.message === "Plate not found!") {
        addCustomerHandler();
      } else {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }
    }
  };

  return (
    <div>
      <ToastContainer />
      {modalOpen && (
        <div
          style={{ zIndex: 10000000 }}
          className={styles.modal_overlay}
          onClick={() => setModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            {/* <h1 className={styles.modal_title}></h1> */}
            <p className={styles.modal_description}>Enter Plate Number...</p>
            <input
              className={styles.modal_input}
              type="text"
              value={plateNumber}
              onChange={(e) => setPlateNumber(e.target.value)}
              placeholder="Enter Plate No"
            />

            <p className={styles.modal_description}>Payment Option</p>
            <select
              className={styles.modal_input}
              value={paymentOption}
              onChange={(e) => setPaymentOption(e.target.value)}
            >
              <option value="">Select Export Option</option>
              <option value="WALLET">WALLET</option>
              <option value="PIN">PIN</option>
            </select>

            {paymentOption === "PIN" && (
              <p className={styles.modal_description}>PIN Type</p>
            )}
            {paymentOption === "PIN" && (
              <select
                className={styles.modal_input}
                value={pinType}
                onChange={(e) => setPinType(e.target.value)}
              >
                <option value="">Select Export Option</option>
                <option value="IEI">IEI</option>
                <option value="CEI">CEI</option>
              </select>
            )}
            <p className={styles.modal_description}>Enter Phone Number</p>
            <input
              className={styles.modal_input}
              type="text"
              value={
                useCustomerNumber ? phoneNumber : "0" + userDetails?.phone_no
              }
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter Phone No"
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                gap: "4px",
              }}
            >
              <input
                type="checkbox"
                name="useCustomerNumber"
                onChange={(e) => setUseCustomerNumber(e.target.checked)}
                checked={useCustomerNumber}
                style={{ width: "18px", height: "18px" }}
              />
              <p style={{ marginLeft: "0px" }}>Use customer's number</p>
            </div>

            <p style={{ marginLeft: "0px" }}>{updateMessage}</p>

            <button
              className={styles.modal_button}
              onClick={() => submitOrderHandler()}
              disabled={loading}
            >
              {loading ? `Loading...` : `Proceed`}
            </button>
          </div>
        </div>
      )}
      <div className="menu" onClick={closeMenuHandler}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="Renew" setShowMenu={props.setShowMenu} />
      <div className={styles.body}>
        <div className={styles.cards_wrapper}>
          {products?.data?.map((product, index) => (
            <div className={styles.card} key={product?.product_details?.id}>
              <h1 className={styles.card_title}>
                {product?.product_details?.product_name}
              </h1>
              <p className={styles.card_description}>
                {product?.product_details?.product_category}{" "}
                <span>{product?.product_details?.product_type}</span>{" "}
              </p>
              <span className={styles.card_amount}>
                NGN{" "}
                {Number(
                  product?.product_details?.product_price
                )?.toLocaleString()}
              </span>
              <p
                onClick={() =>
                  removeFromCartHandler(product?.product_details?.id)
                }
              >
                Remove from cart
              </p>
            </div>
          ))}
          {isLoading &&
            [...Array(3)].map((_, index) => (
              <div key={index}>
                <div className={`${styles.card} ${styles.skeleton}`}></div>
              </div>
            ))}
        </div>
      </div>

      <button
        className={styles.card_button}
        disabled={loading}
        onClick={() => {
          setModalOpen(true);
        }}
        style={{
          position: "fixed",
          bottom: "80px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1000,
          width: "90%",
        }}
      >
        {loading ? `Loading...` : `Submit Order`}
      </button>
      <Footer />
    </div>
  );
}

export default RenewCart;
